import { render, staticRenderFns } from "./BFilterCheckbox.vue?vue&type=template&id=5d2b57dc&"
import script from "./BFilterCheckbox.vue?vue&type=script&lang=js&"
export * from "./BFilterCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports